import { KeyValuePair } from '@common/data-models/misc/key-value-pair';
import { DataType } from '@common/enums/data-type';
import { KnownPropertyTypes } from '@common/enums/known-property-types';

import { AbstractServiceRecord } from './abstract-service-record';

const metaData = {
    Actual: DataType.OBJECT,
    Estimated: DataType.STRING,
    HardHitBack: DataType.DATE,
    HardHitFront: DataType.DATE,
    ReadTime: DataType.NUMBER,
};

KnownPropertyTypes.setFor(metaData);

export class ServiceRecord extends AbstractServiceRecord {
    public Actual?: any;
    public ActualTimeString?: KeyValuePair<string, string>;
    public Estimated?: string;
    public HardHitBack?: string;
    public HardHitFront?: string;
    public ReadTime?: number;

    public getOwnMetaData(): { [id: string]: number } {
        const objectKeys = Object.keys(this);
        const ret = {};
        for (const prop of objectKeys) {
            if (metaData[prop]) ret[prop] = metaData[prop];
        }
        return ret;
    }

    public getMetaData(): { [id: string]: number } {
        const ret = this.getOwnMetaData();
        const parentMetaData = super.getMetaData();

        // merge
        for (const p in parentMetaData) {
            if (!ret[p]) ret[p] = parentMetaData[p];
        }

        return ret;
    }

    public getRawValue(field: string): any {
        if (this.getOwnMetaData()[field]) {
            return this[field];
        }
        return super.getRawValue(field);
    }

    public static instance(data: any): ServiceRecord {
        const ret: ServiceRecord = Object.assign(new ServiceRecord(), data);
        ret.instantiateChildren();
        return ret;
    }
}
